<mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
  <mat-icon matPrefix inline>location_on</mat-icon>
  <mat-label>Enter an Address</mat-label>
  <input matInput #addressField [formControl]="addressFormControl" placeholder="" />
</mat-form-field>
